export class AzureEonApplication {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "applicationId",
            "baseName": "applicationId",
            "type": "string",
            "format": "uuid"
        }
    ];
    static getAttributeTypeMap() {
        return AzureEonApplication.attributeTypeMap;
    }
    constructor() {
    }
}
